import React, { useEffect } from "react";
import { Form, Input, Col, Checkbox, Row, Select, Modal } from 'antd';
import ValidatorHelper from '../../../helpers/ValidatorHelper';
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../../../store/slices/createReportsSlice";

export default function CrmCallHistoryModal({ callHistoryId }) {
    const general = useGeneralStore();
    const reports = useReportsStore()
    const [form] = Form.useForm();

    const status = reports.crmCallStatusReport.data.Status;
    const statusLoading = reports.crmCallStatusReport.loading;
    const loading = reports.crmCallItems.loading;
    const visible = general.view.crmCallItemsModal;

    useEffect(() => {
        reports.getCrmCallStatusReport();
    }, [])



    function onFinish(values) {
        const params = {
            IsProtest: values.IsProtest,
            Description: values.description,
            CallStatus: values.statusId,
        }
        reports.postCrmCallItems({ params: params, callHistoryId: callHistoryId });
        form.resetFields();
        general.ToggleCrmCallItemsModal(false);
        setTimeout(() => {
            reports.getCrmCallHistoryReason(callHistoryId);
        }, 1000);
    }
    function onFinishFailed(errorInfo) {
        form.scrollToField(errorInfo.errorFields[0].typeId, {
            scroll: {
                offsetTop: 65,
            },
        });
    }
    const ItemLayoutCols = {
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
    }
    return (
        <div>
            <Modal
                width={800}
                title={""}
                className="custom-table crm-request-report"
                visible={visible}
                footer={false}
                onCancel={() => general.ToggleCrmCallItemsModal()}
            >
                <Form
                    form={form}
                    className="form-style"
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Row gutter={[16, 16]}>
                        <Col {...ItemLayoutCols}>
                            <Form.Item name="IsProtest" valuePropName="checked" >
                                <Checkbox>آیا شکایت داری؟</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="statusId"
                                label="وضعیت تماس"
                                placeholder="انتخاب کنید"
                                rules={ValidatorHelper.required("وضعیت تماس")}>
                                <Select disabled={statusLoading} loading={statusLoading} placeholder="انتخاب کنید">
                                    {status && status.map((state) => <Select.Option key={state.Id} value={state.Id}>{state.Title}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col {...ItemLayoutCols}>
                            <Form.Item name="description" label="توضیحات">
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item>
                                <button type="primary" className="btn btn-primary waves-effect waves-light float-left">
                                    <i className={loading ? "bx bx-loader bx-spin" : "bx bx-check-double "}></i>
                                    &nbsp;ثبت
                                </button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    );
}
